export const getCart = (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(`${apiInstance.apiURL}/Cart/GetCart`, requestParameters)
}

export const eliminateDuplicateProducts = (
  apiInstance,
  idClient,
  clientPriceListId
) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/EliminateDuplicateProducts?clientId=${idClient}&clientPriceListId=${clientPriceListId}`,
    requestParameters
  )
}

export const addProductsToCart = (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/AddProductsToTheCart`,
    requestParameters
  )
}

export const addToComponent = (apiInstance, idComponent, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/IncrementQuantityComponentFromCart?idComponent=${idComponent}`,
    requestParameters
  )
}

export const removeComponent = (apiInstance, idComponent, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/RemoveComponentFromCart?idComponent=${idComponent}`,
    requestParameters
  )
}

export const removeProduct = (apiInstance, idProduct, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/RemoveProductFromCart?idProduct=${idProduct}`,
    requestParameters
  )
}

export const removeToComponent = (apiInstance, idComponent, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/DecrementQuantityComponentFromCart?idComponent=${idComponent}`,
    requestParameters
  )
}

export const emptyCart = (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(`${apiInstance.apiURL}/Cart/emptyCart`, requestParameters)
}
